export default __webpack_public_path__ + "static/media/M44.4e23990a.svg";